<template>
  <div class="add-peer">
    <div class="add-person">
      <div class="form">
        <div class="add-person-title">
          添加人员
        </div>
        <van-form @submit="onSubmit">
          <van-field
            name="uploader"
            required
            label="识别头像"
            size="large"
            center
            :rules="rules.avatar"
          >
            <template #input>
              <van-uploader
                :after-read="afterReadPerson"
                :before-delete="beforeDelPerson"
                v-model="addPersonFileList"
                :max-count="1"
                multiple
              >
                <img
                  src="@/assets/images/avatar.png"
                  alt=""
                  style="width: 2.75rem; height: 2.75rem;"
                />
              </van-uploader>
            </template>
          </van-field>
          <van-field
            v-model="paramsList.visitorName"
            label="姓名"
            placeholder="请输入姓名"
            size="large"
            required
            :rules="rules.visitorName"
            name="visitorName"
          />
          <van-field
            v-model="paramsList.visitorPhone"
            label="手机号"
            placeholder="请输入手机号"
            size="large"
            required
            :rules="rules.visitorPhone"
            name="visitorPhone"
          />
          <van-field
            v-model="paramsList.visitorIdCrde"
            label="身份证号"
            placeholder="请输入身份证号"
            size="large"
            name="visitorIdCrde"
          />
          <div style="padding: 20px;">
            <van-button
              block
              type="info"
              native-type="submit"
              style="width: 70%; margin: 0 auto;"
            >
              提交
            </van-button>
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import { upload } from '@/utils/upload'
// import assign from '@/mixins/assign'

export default {
  // mixins: [assign],

  data() {
    return {
      addPersonFileList: [],
      paramsList: {},
      rules: {
        avatar: [{ required: true, message: '请上传头像' }],
        visitorName: [{ required: true, message: '请输入姓名' }],
        visitorPhone: [
          {
            required: true,
            message: '请填写正确的手机号',
            pattern: /^1[3456789]{1}\d{9}$/,
          },
        ],
      },
    }
  },
  computed: {
    id() {
      return this.$route.query.visitorId
    },
  },
  mounted() {
    console.log(this.$route.query)
  },
  methods: {
    async afterReadPerson(file) {
      try {
        const imgUrl = await upload(file.file)
        this.paramsList.photoImg = imgUrl
      } catch (error) {
        this.$toast('上传失败，请重试')
        this.paramsList.photoImg = ''
        this.addPersonFileList.splice(0, 1)
      }
    },
    beforeDelPerson(item, obj) {
      this.addPersonFileList.splice(obj.index, 1)
      this.paramsList.photoImg = ''
    },
    onSubmit(values) {
      this.setPerson()
    },
    async setPerson() {
      const { data, msg, code } = await this.$https.setPerson({
        permitType: 0,
        visitorId: this.id,
        ...this.paramsList,
        userId: this.$store.state.userId,
      })
      if (code !== 200) {
        this.$toast('添加失败')
        return false
      }
      this.$toast('添加人员成功')
      this.paramsList = {}
      this.addPersonFileList.splice(0, 1)
    },
  },
}
</script>

<style lang="scss" scoped>
.add-person {
  padding: 15px 20px;
  .add-person-title {
    padding: 10px;
    border-bottom: 1px solid rgba(244, 244, 246, 0.99);

    /* text-align: center; */
    font-weight: bold;
    /* margin-bottom: 10px; */
    background: #fff;
  }
  .add-btn-group {
    margin-top: 20px;
  }
}
.form {
  border-radius: 0.75rem;
  overflow: hidden;
  background: #fff;
}
::deep .van-uploader__preview-image {
  border-radius: 50%;
}
</style>
